const API_BASE = process.env.REACT_APP_API_URL || '';
const WORKSHOP_SLUG = (process.env.REACT_APP_WORKSHOP_SLUG || '').trim();
const PUBLIC_FUNNEL_UNAVAILABLE_CODE = 'funnel_unavailable';
const PUBLIC_FUNNEL_UNAVAILABLE_MESSAGE = 'PUBLIC_FUNNEL_UNAVAILABLE';

function withWorkshopContext(path) {
  if (!WORKSHOP_SLUG) {
    return `${API_BASE}${path}`;
  }

  const separator = path.includes('?') ? '&' : '?';
  return `${API_BASE}${path}${separator}workshopSlug=${encodeURIComponent(WORKSHOP_SLUG)}`;
}

async function buildApiError(response, fallbackMessage) {
  const body = await response.json().catch(() => ({}));
  const error = new Error(body.error || fallbackMessage);
  error.status = response.status;
  error.code = body.code || '';
  return error;
}

function markPublicFunnelUnavailable(error) {
  error.message = PUBLIC_FUNNEL_UNAVAILABLE_MESSAGE;
  error.code = PUBLIC_FUNNEL_UNAVAILABLE_CODE;
  return error;
}

export async function fetchWorkshopConfig() {
  const response = await fetch(withWorkshopContext('/api/workshops/current/public'));
  if (!response.ok) {
    const error = await buildApiError(response, 'Failed to fetch workshop config');
    if (response.status === 404 || error.code === PUBLIC_FUNNEL_UNAVAILABLE_CODE) {
      throw markPublicFunnelUnavailable(error);
    }
    throw error;
  }
  return response.json();
}

export async function fetchLeads() {
  const response = await fetch(withWorkshopContext('/api/leads'));
  if (!response.ok) throw new Error('Failed to fetch leads');
  return response.json();
}

export async function createLead(lead) {
  const response = await fetch(withWorkshopContext('/api/leads'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(lead),
  });

  if (!response.ok) {
    const error = await buildApiError(response, 'Failed to create lead');
    if (error.code === PUBLIC_FUNNEL_UNAVAILABLE_CODE) {
      throw markPublicFunnelUnavailable(error);
    }
    throw error;
  }

  return response.json();
}

export async function fetchAvailableAppointments() {
  const response = await fetch(withWorkshopContext('/api/appointments/available'));
  if (!response.ok) {
    const error = await buildApiError(response, 'Failed to fetch available appointments');
    if (response.status === 404 || error.code === PUBLIC_FUNNEL_UNAVAILABLE_CODE) {
      throw markPublicFunnelUnavailable(error);
    }
    throw error;
  }
  return response.json();
}

export async function prepareAppointmentBooking(payload) {
  const response = await fetch(withWorkshopContext('/api/appointments/prepare-booking'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const error = await buildApiError(response, 'Failed to prepare appointment booking');
    if (error.code === PUBLIC_FUNNEL_UNAVAILABLE_CODE) {
      throw markPublicFunnelUnavailable(error);
    }
    throw error;
  }

  return response.json();
}

export async function bookAppointment(payload) {
  const response = await fetch(withWorkshopContext('/api/appointments/book'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const error = await buildApiError(response, 'Failed to book appointment');
    if (error.code === PUBLIC_FUNNEL_UNAVAILABLE_CODE) {
      throw markPublicFunnelUnavailable(error);
    }
    throw error;
  }

  return response.json();
}
